import React, { useState, useEffect } from 'react';
import '../App.css';
import axios from "axios";
import { Button, ListGroup, Table, Row, Col, Modal, Form } from 'react-bootstrap';
//import Navbar from "./Navbar_vecchio";
//import Nuovo_Alunno_Edit from "./Alunno_x0_Edit";
//import DatePicker from "react-datepicker";
//import Crea_nuovo_alunno from "./Alunno_x0_1_crea_alunno";
import { useAuth0 } from "@auth0/auth0-react";
import JSONPretty from 'react-json-pretty';
import Nuova_Classe_Edit from "./Classe_x0_Edit";
import Dropdown_tutor from "./Classe_x2_assegna_tutor";
import Visualizza_lista_documenti_pdf from "../Funzioni_comuni_pdf_visualizza.jsx";

import { BsTrash } from 'react-icons/bs';


//const { Controlla_se_lavoro_in_debug } = require('../Funzioni_comuni')


    function check_variabili_oggetto(obj, ...args) {
        return args.reduce((obj, level) => obj && obj[level], obj)
    }

    function Controlla_se_lavoro_in_debug (user) {


    let debug = false
    let email_google = check_variabili_oggetto (user, 'email')  
      
        if (email_google === 'p.sordi@ipsiapacinotti.it' || 
            email_google === 'g.falcitelli@ipsiapacinotti.it' ||
            email_google === 'dirigente@ipsiapacinotti.it' ||
            email_google === 't.fogli@ipsiapacinotti.it') {
        }
        if (email_google === 'paolosordi12@gmail.com' ||
            email_google === 'dirigente@ipsiapacinotti.it' ||
            email_google === 't.fogli@ipsiapacinotti.it') {
              debug=true
        }
    
        return debug
    }


const Gestione_Classi = (props) => {
    const [input, setInput] = useState({
        nome: '',
        corso: ''

    });
    const [lista_classi, SET_lista_classi] = useState([]);
    const [lista_tutor, SET_lista_tutor] = useState([]);

    const [variab_aggiorna, SET_variab_aggiorna] = useState(false);
    const [end_Date, set_End_Date] = useState(new Date());
    const { user, isAuthenticated } = useAuth0();
    const [tutor, SET_tutor] = useState('');

    useEffect(() => {

        if (Controlla_se_lavoro_in_debug(user)) {
            Carica_classi_x_account()
            Carica_tutor_x_account()
            Controlla_se_esiste_Account()
        }
         
        
    }, [variab_aggiorna, user]);



    const Carica_classi_x_account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_domande_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/classi/classi_carica_tutti/' + utente)
            .then((res) => {
                console.log('CLASSI appena fecciate da mongo')
                console.log(res.data)
                SET_lista_classi(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }


    const Carica_tutor_x_account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_domande_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/tutor/tutor_carica_tutti/' + utente)
            .then((res) => {
                console.log('TUTOR appena fecciate da mongo')
                console.log(res.data)
                SET_lista_tutor(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }


    const Controlla_se_esiste_Account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('XXXXXXXXXXXXXXX Carica_tutor_x_account')
        console.log(user.email)
     
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        
        axios.get('/tutor/cerca1/' + user.email)
            .then((res) => {
                console.log('un TUTOR appena fecciato da mongo')
                console.log(res.data)

                // idroslab gli account restituiti sono comunque una lista
                SET_tutor(res.data[0])
            }).catch((error) => {
                console.log(error)
            });
    }
    

    function handleChange(event) {
        const { name, value } = event.target;

        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }

    function handleClick(event) {
        event.preventDefault();
        const nuova_classe = {
            nome: input.nome,
            corso: input.corso
        }

        axios.post('/classi/salva_nuovo', nuova_classe)
        .then((res) => {
            //                console.log('Aggiunta una classe')
            SET_variab_aggiorna(current => !current)
         }).catch((error) => {
            console.log('Cancella')

        });
     }

//         {/* idroslab  due variabili passate dall-eventi */}
     
    function Cancella(id1,id2) {
        console.log('Cancella')
        console.log(id1)
        console.log(id2)
        SET_variab_aggiorna(current => !current)
        axios.put('/classi/togli_tutor_dalla_classe/' + id1 + '/' + id2) 
            .then((res) => {
            //                console.log('Aggiunta una classe')
            console.log(res.data)
        }).catch((error) => {
            console.log(error)
        });
    }



    return (
        <div className='container'>
            
            {(props.account_dati.utente_debug) &&
        
                <JSONPretty data={user} />
            }
            <div className='container'>
                <h2>Inserisci nuova classe </h2>
                <form>
                    <div className='form-group'>
                        <input onChange={handleChange} name="nome" placeholder="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                        <input onChange={handleChange} name="corso" placeholder="corso" value={input.corso} autoComplete="off" className="form-control"></input>

                    </div>

                    <div class="d-flex flex-row-reverse">
                        <button onClick={handleClick} className="btn btn-lg btn-info">Salva</button>
                    </div>
                </form>
            </div>



            <div className='container'>

                <ListGroup>
                    {lista_classi.map(function (item, index2) {
                        {
                            //                        console.log(item)
                        return <div>
                            <Row>
                            <Nuova_Classe_Edit classe={item} tutor={tutor} variab_aggiorna={variab_aggiorna} SET_variab_aggiorna={SET_variab_aggiorna} />
                                <Col>
                                  
                                    Classe: <strong>{item.nome}</strong> &nbsp; 
                                    Corso: <strong>{item.corso}</strong>
                                </Col>
                                <Col>
                                    <Dropdown_tutor lista_tutor={lista_tutor} classe={item} SET_variab_aggiorna= {SET_variab_aggiorna}/>

                                </Col>
                                <Col>
                                        {/* idroslab  esempio di map*/}

                                    {item.array_tutor.map(function (item_tutor, index2) {
                                        {
                                            //                        console.log(item)
                                            return <div>
                                                <Row>
                                                    <Col>
                                                    {item_tutor.cognome} &nbsp; {item_tutor.nome}
                                                    </Col>
                                                    <Col>
                                                    <Button variant="primary" onClick={() => Cancella(item._id,item_tutor._id)}>
                                                           <BsTrash />
                                                    </Button>
                                                    </Col>
                                                </Row>
                                                <hr class="rounded"></hr>

                                            </div>
                                        }
                                    })
                                    }
                                </Col>
                                {(props.account_dati.utente_debug) &&
        
                                    <JSONPretty data={item} />
                                }


                            </Row>
                            <Row>

                            <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                        <th>#</th>
                                        <th>Tipologia</th>
                                        <th>Data Caricamento</th>
                                        
                                        <th>Tutor</th>
                                        <th>Admin</th>
                                
                                        <th>Azioni</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   
            
                                    <Visualizza_lista_documenti_pdf attore_tipo= {'classi'} attore={item} tutor={props.tutor} tipologia_documento={'File_word_rischio_basso'}  SET_variab_aggiorna={SET_variab_aggiorna}/> 
                                    <Visualizza_lista_documenti_pdf attore_tipo= {'classi'} attore={item} tutor={props.tutor} tipologia_documento={'File_word_rischio_medio'} SET_variab_aggiorna={SET_variab_aggiorna}/> 
                                    <Visualizza_lista_documenti_pdf attore_tipo= {'classi'} attore={item} tutor={props.tutor} tipologia_documento={'File_word_rischio_alto'} SET_variab_aggiorna={SET_variab_aggiorna}/> 

                                    </tbody>
                                </Table>                                
                         
                            </Row>
                            <hr class="rounded"></hr>

                        </div>
                        }
                    })
                    }
                </ListGroup>

            </div>

        </div >

    )
}

export default Gestione_Classi;
